import { useMemo } from 'react';

import { paths } from 'src/routes/paths';

import { useLocalStorage } from 'src/hooks/use-local-storage';

import { useTranslate } from 'src/locales';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useTranslate();
  const { state } = useLocalStorage('entity');

  const entity_id = useMemo(() => state?.id, [state?.id]);
  const parent_entity_id = useMemo(() => state?.parent, [state?.parent]);

  const data = useMemo(
    () => [
      {
        subheader: '',
        items: [
          {
            title: t('nav.menu.engagement.dashboard'),
            path: paths.entity.modules.engagement.dashboard.root(parent_entity_id || entity_id),
            icon: <Iconify icon="material-symbols:dashboard-outline" />,
          },
          {
            title: t('nav.menu.engagement.pillars'),
            path: paths.entity.modules.engagement.settings.root(parent_entity_id || entity_id),
            icon: <Iconify icon="mdi:pillar" />,
          },
          {
            title: t('nav.menu.engagement.actions'),
            path: paths.entity.modules.engagement.actions.root(parent_entity_id || entity_id),
            icon: <Iconify icon="mdi:file-document-outline" />,
          },
          {
            title: t('nav.menu.engagement.planning'),
            path: paths.entity.modules.engagement.planning.root(parent_entity_id || entity_id),
            icon: <Iconify icon="mdi:calendar" />,
          },
        ],
      },
    ],
    [t, entity_id, parent_entity_id]
  );

  return data;
}
